export default __webpack_public_path__ + "static/media/diarybot.293784cf.png";